/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * NegativeIcon Icon
 * @author Anuja Gaikwad
 * @file NegativeIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

function NegativeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM12.1572 5.84277C11.8671 5.55271 11.3966 5.55267 11.1064 5.84277L9 7.9502L6.89355 5.84277C6.60343 5.55264 6.1329 5.55264 5.84277 5.84277C5.55264 6.1329 5.55264 6.60343 5.84277 6.89355L7.9502 9L5.84277 11.1064C5.55267 11.3966 5.55271 11.8671 5.84277 12.1572C6.1329 12.4474 6.60343 12.4474 6.89355 12.1572L9 10.0508L11.1064 12.1572C11.3966 12.4474 11.8671 12.4474 12.1572 12.1572C12.4474 11.8671 12.4474 11.3966 12.1572 11.1064L10.0508 9L12.1572 6.89355C12.4474 6.60343 12.4474 6.1329 12.1572 5.84277Z"
        fill="#B20900"
      />
    </SvgIcon>
  );
}
export default NegativeIcon;
